import { PROCESS_IDENTIFIERS } from '../process';

const PROCEDURE_IDENTIFIERS = {
  MEP_REVISION: '62bdc33fb314687233f2b12f',
  ...PROCESS_IDENTIFIERS,
  COMPLETED_PROCESS: '65e94b91a44046c1a9da52a6',
};

const PROCEDURE_IDENTIFIERS_ENUM = Object.keys(PROCEDURE_IDENTIFIERS);
const PROCEDURE_IDENTIFIERS_IDS_ENUM = Object.values(PROCEDURE_IDENTIFIERS);

export {
  PROCEDURE_IDENTIFIERS,
  PROCEDURE_IDENTIFIERS_ENUM,
  PROCEDURE_IDENTIFIERS_IDS_ENUM,
};
